import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { EstatusJSON } from "../../models/EstatusJSON";
import { ViewsAPIService } from "../API/ViewsAPI.service";

@Injectable({
  providedIn: "root",
})
export class ViewsService{
  
  public isLoading$: Subject<boolean> = new Subject<boolean>();
  
  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor(private viewService: ViewsAPIService) {
  }

  getList(): Observable<EstatusJSON> {
    return this.viewService.getList();
  }

  getPermissionList(): Observable<EstatusJSON> {
    return this.viewService.getPermissionList();
  }

  
  
}
